import React from 'react';
import { concat, has, reduce } from 'lodash';
import UIUtils from 'js/lib/UIUtils';
import { isCapsuleCluster } from 'js/lib/PipelineUtils';
import { connect } from 'react-redux';
import { loadDataMaps } from 'js/actions';
import { getSortedDataMaps } from 'js/reducers/dataMaps';
import { GET_DATA_MAPS_REQUEST } from 'js/constants/actionTypes';
import TransformView from '../elements/schema-editor/schema-inspector/transforms/TransformView';
import { TextField } from 'new/elements/TextField';

const colors = { r: 84, g: 93, b: 108 };
class TransformRecipe extends React.Component {
  render() {
    const {
      dataMaps,
      attrTransforms,
      groupedTransformRules,
      selectedBrowserType,
      metaDataSpec,
      inputSchema,
      transformData,
      isLoadingDataMaps,
      loadDataMaps,
      onLoadReusableTransforms,
    } = this.props;

    const ignoreDest =
      transformData?.name && groupedTransformRules.rules[transformData.name]?.ignoreDest;

    return (
      <div className="inspector-transform">
        {!ignoreDest && (
          <>
            <div
              className="recipe-input-row"
              style={{ alignItems: 'center', marginBottom: 'var(--spacing-md)' }}
            >
              <label className="recipe-input-label">Output Attribute</label>
              <div className="recipe-input-container">
                <TextField
                  fullWidth
                  value={transformData.__destAttr || ''}
                  onChange={this._handleAttrNameChanged}
                />
              </div>
            </div>
          </>
        )}
        <div className="recipe-input-row recipe-input-column">
          <label className="recipe-input-label">Function</label>
          <div className="recipe-input-container">
            <TransformView
              transformData={transformData}
              allAttributes={inputSchema}
              colors={colors}
              isRoot={true}
              dataMaps={dataMaps}
              attrTransforms={attrTransforms}
              groupedTransformRules={groupedTransformRules}
              selectedBrowserType={selectedBrowserType}
              metaDataSpec={metaDataSpec}
              allTransforms={{
                groupOrder: groupedTransformRules.groupOrder,
                groupRules: groupedTransformRules.groupRules,
              }}
              allowedTransforms={{
                groupOrder: groupedTransformRules.groupOrder,
                groupRules: groupedTransformRules.groupRules,
              }}
              isLoadingDataMaps={isLoadingDataMaps}
              loadDataMaps={loadDataMaps}
              onLoadReusableTransforms={onLoadReusableTransforms}
              onTransformChanged={this._handleTransformChanged}
            />
          </div>
        </div>
      </div>
    );
  }

  _handleTransformChanged = (data) => {
    const { transformData, onChangeTransformData } = this.props;
    const newTransformData = { ...data };

    if (transformData.__destAttr) {
      newTransformData.__destAttr = transformData.__destAttr;
    }

    onChangeTransformData(newTransformData);
  };

  _handleAttrNameChanged = (e) => {
    const { transformData, onChangeTransformData } = this.props;
    const newTransformData = {
      ...transformData,
      __destAttr: e.target.value,
    };

    onChangeTransformData(newTransformData);
  };

  _handleParentPathChanged = (e) => {
    const { transformData, onChangeTransformData } = this.props;
    const newTransformData = {
      ...transformData,
      parentPath: e.target.value,
    };

    onChangeTransformData(newTransformData);
  };
}

const mapStateToProps = (state, { dataSet }) => {
  let {
    entities: { transforms: txEntities },
    schemaEditor: { fromSchema, metaDataSpec },
    transforms: { attributeTransforms, groupedTransformRules },
    request,
  } = state;

  let attrTransforms = reduce(
    concat(attributeTransforms.sortedIds, attributeTransforms.sortedPublicIds),
    (acc, txId) => {
      if (has(txEntities, txId)) {
        acc[txId] = txEntities[txId];
        acc[txId].decoded = has(attributeTransforms.decoded, txId)
          ? attributeTransforms.decoded[txId].decoded
          : null;
      }
      return acc;
    },
    {},
  );

  const groupedTransformRulesCloned = structuredClone(groupedTransformRules);
  groupedTransformRulesCloned.groupRules = UIUtils.filterGroupedRulesByDataset(
    dataSet,
    groupedTransformRulesCloned.groupRules,
  );

  /**
   * For Capsule Clusters, we don't want to show the lookupGroup
   */
  if (isCapsuleCluster(dataSet)) {
    groupedTransformRulesCloned.groupOrder = groupedTransformRulesCloned.groupOrder.filter(
      (g) => g !== 'lookupGroup',
    );
    delete groupedTransformRulesCloned.groupRules['lookupGroup'];
  }

  let isLoadingDataMaps = !!request[GET_DATA_MAPS_REQUEST];

  return {
    dataMaps: getSortedDataMaps(state),
    attrTransforms,
    groupedTransformRules: groupedTransformRulesCloned,
    metaDataSpec,
    inputSchema: fromSchema.flat,
    isLoadingDataMaps,
  };
};

export default connect(mapStateToProps, {
  loadDataMaps,
})(TransformRecipe);
